export default __webpack_public_path__ + "static/media/excel.34b7f3f5.png";